module.exports = __webpack_public_path__ + "static/media/addEditLeaveBalances.ef4213c8.svg";